import React from "react";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";

const LOGO = "https://customer-assets.emergentagent.com/job_c6bd5712-5f81-483e-8d1a-423c18662714/artifacts/8xuq627e_LOGO%20ARIAF.jpg.jpeg";

export function BrandLogo({ size = 44, showText = true }) {
  const { t } = useLang();
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div
        className="relative rounded-full overflow-hidden ring-2 ring-brand-gold/60 bg-white flex-shrink-0"
        style={{ width: size, height: size }}
      >
        <img src={LOGO} alt="Ariaf" className="w-full h-full object-cover" />
      </div>
      {showText && (
        <div className="leading-tight">
          <div className="font-serif text-lg md:text-xl text-brand-navy tracking-wide">Ariaf Catering</div>
          <div className="text-[10px] md:text-[11px] uppercase tracking-[0.25em] text-brand-orange font-semibold">
            {t("tagline")}
          </div>
        </div>
      )}
    </div>
  );
}

export function LanguageSwitcher() {
  const { lang, setLang, languages } = useLang();
  const label = { tr: "TR", ar: "عربي", en: "EN", ru: "RU" };
  return (
    <div className="flex items-center gap-1 rounded-full border border-brand-navy/15 bg-white/70 backdrop-blur px-1 py-1" data-testid="language-switcher">
      {languages.map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-${l}`}
          className={`px-2.5 py-1 text-xs font-medium rounded-full transition ${lang === l ? "bg-brand-navy text-white" : "text-brand-navy hover:bg-brand-navy/5"}`}
        >
          {label[l]}
        </button>
      ))}
    </div>
  );
}

export { LOGO as ARIAF_LOGO };
